import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuDropdown',
  props: {
    activeKey: {},
    title: {},
    routerLink: {},
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const router = useRouter()
function navigate() {
  if (props.routerLink) {
    router.push(props.routerLink) // Navigate to the specified router link
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (_openBlock(), _createBlock(_component_a_sub_menu, {
    onTitleClick: navigate,
    key: _ctx.activeKey,
    title: _ctx.title,
    open: _ctx.isOpen
  }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "links")
    ]),
    _: 3
  }, 8, ["title", "open"]))
}
}

})